import { EntityAdapter, EntityState } from '@ngrx/entity';

export const ONE_TIME_PAYMENT_STATUS = {
    PENDING: 'PENDING', // Payment date not reached 
    KEPT: 'KEPT', // Paid
    BROKEN: 'BROKEN', // Missed payment date
    CANCELLED: 'CANCELLED' // Deleted or cancelled
};

export interface BankAccountPay {
    id: string;
    last4Number: string;
    bankName: string;
}

export interface Payment {
    id: string;
    paymentReference: string;
    paymentMethod: string;
    date: string;
    paymentAmount: number;
    satisfied: boolean;
    reversed: boolean;
    reversedReason: string;
    bankAccount: BankAccountPay;
}

export interface NextPayment {
    id: string;
    date: string;
    paymentAmount: number;
    bankAccount: BankAccountPay;
}

export interface PaymentPlan {
    nextPayment: NextPayment;
    payments: Payment[];
}

export interface PaymentAPIResponse {
    isSuccess: boolean;
    response: Payment[];
}

export interface PaymentList {
    list: PaymentData[]
}

export interface PaymentsEntityState extends EntityState<PaymentData> {
    loaded: boolean;
    nextPayment: NextPayment;
}

export interface PaymentsAdapter extends EntityAdapter<PaymentData> { }

export interface PaymentData extends Payment {
    promiseId?: number;
    applicationId?: string;
    paymentStatus?: string;
}
